import classNames from "classnames"
import { formatIconUrl } from "../module"
import { getRotatedIconsHardCodedValues } from "@nova/constants"

const NUMBER_OF_COLUMNS = 6

export const InspectorPanelIconPackIcon = ({
    name,
    url,
    index,
    isSelected,
    onSelect,
}: {
    id: string
    name: string
    url: string
    index: number
    isSelected: boolean
    onSelect: () => void
}) => {
    const columnIndex = index % NUMBER_OF_COLUMNS

    return (
        <div
            className={classNames(
                "relative cursor-pointer rounded-md border flex items-center justify-center w-8 h-8 p-0.5 group",
                {
                    "border-gray-0": isSelected,
                    "border-transparent": !isSelected,
                }
            )}
            onClick={() => onSelect()}
        >
            <svg
                data-src={`/${formatIconUrl(url)}`}
                width={28}
                height={28}
                style={{ transform: `rotate(${getRotatedIconsHardCodedValues(url)}deg)` }}
            />
            <div
                className={classNames(
                    "absolute w-[7.5rem] top-full invisible group-hover:visible overflow-hidden",
                    {
                        "left-0": columnIndex === 0,
                        "right-0 text-right": columnIndex === NUMBER_OF_COLUMNS - 1,
                        "left-1/2 -translate-x-1/2 text-center":
                            columnIndex !== 0 && columnIndex !== NUMBER_OF_COLUMNS - 1,
                    }
                )}
            >
                <small className="text-gray-0 whitespace-nowrap inline-block group-hover:animate-slide">
                    {name}
                </small>
            </div>
        </div>
    )
}
